"use client";

import type React from "react";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../supabase.ts";
import Loading from "./Loading.tsx";
import { Box } from "@chakra-ui/react";
import { useAppTheme } from "../ThemeContext.tsx";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { resolvedTheme } = useAppTheme();
  const isDark = resolvedTheme === "dark";
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setIsAuthenticated(!!session);
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return <Loading />;
  }

  return isAuthenticated ? (
    <Box bg={isDark ? "gray.800" : "gray.100"} minHeight="100vh">
      {children}
    </Box>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default PrivateRoute;
